import FeatureGates from '@atlaskit/feature-gate-js-client';
import { usePostOfficeRoute } from '@atlassian/post-office-context';

export const usePostOfficeSearchParams = (): Record<string, string> => {
	const route = usePostOfficeRoute();

	const includeSearchParams = FeatureGates.checkGate('po-enable-query-params-screen-space-flags');
	const includePathname = FeatureGates.checkGate(
		'po-enable-query-params-pathname-screen-space-flags',
	);

	let result: Record<string, string> = {};

	if (includeSearchParams) {
		if (route?.searchParams) {
			result = Object.fromEntries(route.searchParams);
		}
	}

	if (includePathname) {
		if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') {
			result = { ...result, pathname: window.location.pathname };
		}
	}

	return result;
};
